var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"22","transform":"rotate(-180 22 22)","key":0}),React.createElement("path",{"d":"M25.0025 31L27 28.8359L20.5116 21.791L27 14.7461L25.0025 12.582L16.5024 21.791L25.0025 31Z","fill":"white","key":1})]);
}

ChevronLeftInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
